document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (event) {
    const dropdownOption = event.target.closest("[data-popout-option]");
    const toggle = event.target.closest("[data-popout-toggle]");
    const radioInput = event.target.closest("[data-single-option-selector]");
    const popout = event.target.closest(".select-popout");
    const sellingLabel = event.target.closest(
      '.recommended-box input[name="selling_plan"] ~ label',
    );

    if (dropdownOption) {
      event.preventDefault();

      const popoutEl = dropdownOption.closest(".select-popout");
      const list = popoutEl.querySelector("[data-popout-list]");
      const input = popoutEl.querySelector("[data-popout-input]");
      const toggleText = popoutEl.querySelector("[data-popout-toggle-text]");
      const selectedSwatch = popoutEl.querySelector("[data-selected-swatch]");
      const wrapper = popoutEl.closest(".selector-wrapper");
      const legendValue = wrapper?.querySelector("[data-option-value]");

      const value = dropdownOption.dataset.value;
      const color = dropdownOption.dataset.swatchColor || "#ccc";

      if (input) {
        input.value = value;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (toggleText) toggleText.textContent = value;

      if (selectedSwatch) {
        selectedSwatch.style.setProperty("--swatch", color);
      }

      if (legendValue) {
        legendValue.textContent = value;
        legendValue.style.setProperty("--swatch", color);
      }

      popoutEl
        .querySelectorAll(".select-popout__item")
        .forEach((el) => el.classList.remove("is-active"));
      dropdownOption
        .closest(".select-popout__item")
        ?.classList.add("is-active");

      list?.classList.remove("popout-list--visible");
      return;
    }

    if (radioInput) {
      const wrapper = radioInput.closest(".selector-wrapper");
      const legendValue = wrapper?.querySelector("[data-option-value]");
      const label = radioInput.closest("label");
      const swatch = label?.querySelector(".custom-swatch-box");
      const root = radioInput.closest(".custom_variants");

      const color = swatch?.dataset.swatchColor || "#ccc";

      if (legendValue) {
        legendValue.textContent = radioInput.value;
        legendValue.style.setProperty("--swatch", color);
      }

      if (root) {
        resolveVariant(root);
      }

      return;
    }

    if (toggle) {
      event.preventDefault();

      const popoutEl = toggle.closest(".select-popout");
      const list = popoutEl.querySelector("[data-popout-list]");

      document
        .querySelectorAll(
          ".select-popout [data-popout-list].popout-list--visible",
        )
        .forEach((ul) => {
          if (ul !== list) ul.classList.remove("popout-list--visible");
        });

      list?.classList.toggle("popout-list--visible");
      return;
    }

    if (sellingLabel) {
      const input = sellingLabel.previousElementSibling;
      if (!input || input.name !== "selling_plan") return;

      input.checked = true;

      const recommendedBox = sellingLabel.closest(".recommended-box");
      if (!recommendedBox) return;

      const sellingKey = recommendedBox.dataset.selling;
      if (!sellingKey) return;

      const productContainer = recommendedBox.closest(".product") || document;

      const customVariants = productContainer.querySelector(
        `.custom_variants[data-type="${sellingKey}"]`,
      );
      if (!customVariants) return;

      const proArea = productContainer.querySelector(".pro_btn_area");
      if (!proArea) return;

      const targetButton = proArea.querySelector(
        `.one_time_pro[date_rel="${sellingKey}"]`,
      );
      if (!targetButton) return;

      const form = targetButton.querySelector("form");
      if (!form) return;

      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      const existingPlan = form.querySelector('input[name="selling_plan"]');
      if (existingPlan) existingPlan.remove();

      const sellingInput = document.createElement("input");
      sellingInput.type = "hidden";
      sellingInput.name = "selling_plan";
      sellingInput.value = input.value;

      idInput.insertAdjacentElement("afterend", sellingInput);

      return;
    }

    if (!popout) {
      document
        .querySelectorAll(
          ".select-popout [data-popout-list].popout-list--visible",
        )
        .forEach((ul) => ul.classList.remove("popout-list--visible"));
    }
  });

  document.addEventListener("change", function (event) {
    const input = event.target;

    if (input.matches("[data-single-option-selector]")) {
      const root = input.closest(".custom_variants");
      if (!root) return;
      resolveVariant(root);
      return;
    }

    if (input.matches('.recommended-box input[name="selling_plan"]')) {
      const recommendedBox = input.closest(".recommended-box");
      if (!recommendedBox) return;

      const sellingKey = recommendedBox.dataset.selling;
      if (!sellingKey) return;

      const productContainer = recommendedBox.closest(".product") || document;

      const customVariants = productContainer.querySelector(
        `.custom_variants[data-type="${sellingKey}"]`,
      );
      if (!customVariants) return;

      const proArea = productContainer.querySelector(".pro_btn_area");
      if (!proArea) return;

      const targetButton = proArea.querySelector(
        `.one_time_pro[date_rel="${sellingKey}"]`,
      );
      if (!targetButton) return;

      const form = targetButton.querySelector("form");
      if (!form) return;

      const idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      const existingPlan = form.querySelector('input[name="selling_plan"]');
      if (existingPlan) existingPlan.remove();

      const sellingInput = document.createElement("input");
      sellingInput.type = "hidden";
      sellingInput.name = "selling_plan";
      sellingInput.value = input.value;

      idInput.insertAdjacentElement("afterend", sellingInput);

      return;
    }
  });

  document.querySelectorAll(".custom_variants").forEach((root) => {
    resolveVariant(root);
  });
});

function resolveVariant(root) {
  const selectedOptions = [];

  root.querySelectorAll("[data-single-option-selector]").forEach((input) => {
    if (input.type === "radio") {
      if (input.checked) selectedOptions.push(input.value);
    } else {
      selectedOptions.push(input.value);
    }
  });

  const variantsScript = root.querySelector('noscript[for="product-variants"]');
  if (!variantsScript) return;

  let variants;
  try {
    variants = JSON.parse(variantsScript.textContent.trim());
  } catch (e) {
    return;
  }

  const matchedVariant = variants.find((variant) =>
    variant.options.every((opt, index) => opt === selectedOptions[index]),
  );

  if (!matchedVariant) return;

  updateExternalForm(root, matchedVariant);
}

function updateExternalForm(root, variant) {
  const typeValue = root.dataset.type;
  if (!typeValue) return;

  const productContainer = root.closest(".product") || document;
  const proArea = productContainer.querySelector(".pro_btn_area");
  if (!proArea) return;

  const targetButton = proArea.querySelector(
    `.one_time_pro[date_rel="${typeValue}"]`,
  );
  if (!targetButton) return;

  const form = targetButton.querySelector("form");
  if (!form) return;

  const idInput = form.querySelector('input[name="id"]');
  if (!idInput) return;

  idInput.value = variant.id;

  const existingPlan = form.querySelector('input[name="selling_plan"]');
  if (existingPlan) existingPlan.remove();

  if (
    !variant.selling_plan_allocations ||
    !variant.selling_plan_allocations.length
  )
    return;

  const recommendedBox = productContainer.querySelector(
    `.recommended-box[data-selling="${typeValue}"]`,
  );
  if (!recommendedBox) return;

  const checkedPlan = recommendedBox.querySelector(
    'input[name="selling_plan"]:checked',
  );
  if (!checkedPlan) return;

  const sellingInput = document.createElement("input");
  sellingInput.type = "hidden";
  sellingInput.name = "selling_plan";
  sellingInput.value = checkedPlan.value;

  idInput.insertAdjacentElement("afterend", sellingInput);
}

document.addEventListener("click", function (event) {
  const root = event.target.closest('.custom_variants[data-type="onetime"]');
  if (!root) return;

  const optionInput = event.target.closest("[data-single-option-selector]");
  if (!optionInput) return;

  setTimeout(() => {
    const selectedOptions = [];

    root.querySelectorAll("[data-single-option-selector]").forEach((input) => {
      if (input.type === "radio") {
        if (input.checked) selectedOptions.push(input.value);
      } else {
        selectedOptions.push(input.value);
      }
    });

    const variantsScript = root.querySelector(
      'noscript[for="product-variants"]',
    );
    if (!variantsScript) return;

    let variants;

    try {
      variants = JSON.parse(variantsScript.textContent.trim());
    } catch (e) {
      console.log("Variant JSON parse error:", e);
      return;
    }

    const matchedVariant = variants.find((variant) =>
      variant.options.every((opt, index) => opt === selectedOptions[index]),
    );

    if (!matchedVariant) return;
    if (!matchedVariant.featured_image?.src) return;

    let variantImageUrl = matchedVariant.featured_image.src
      .replace("//boobiebars.myshopify.com", "")
      .split("?")[0];
    const photos = document.querySelectorAll(".product__thumb__link");
    if (!photos.length) return;

    photos.forEach((photo) => {
      let photoSrc = photo
        .getAttribute("href")
        .replace("//boobiebars.myshopify.com", "")
        .split("?")[0];
      if (photoSrc === variantImageUrl) photo.click();
    });
  }, 10);
});
